export interface GeoLocationResponse {
  city: string;
  country: string; // this one
  hostname: string;
  ip: string;
  loc: string;
  org: string;
  postal: string;
  region: string;
  timezone: string;
}
